import React, { useEffect, useState } from "react";
import { getAllSongs } from "../api";
import { actionType } from "../Context/reducer";
import { useStateValue } from "../Context/StateProvider";
import Filter from "./Filter";
import Header from "./Header";
import SearchBar from "./SearchBar";
import { motion } from "framer-motion";
import Comments from "./Comments";
import { BsPlayCircle } from "react-icons/bs";
import { AiOutlineCloseCircle } from "react-icons/ai";
const Home = () => {
  const [
    {
      searchTerm,
      isSongPlaying,
      song,
      allSongs,
      artistFilter,
      filterTerm,
      albumFilter,
      languageFilter,
    },
    dispatch,
  ] = useStateValue();

  const [filteredSongs, setFilteredSongs] = useState(null);

  useEffect(() => {
    if (!allSongs) {
      getAllSongs().then((data) => {
        dispatch({
          type: actionType.SET_ALL_SONGS,
          allSongs: data.data,
        });
      });
    }
  }, []);

  useEffect(() => {
    if (searchTerm.length > 0) {
      const filtered = allSongs.filter(
        (data) =>
          data.artist.toLowerCase().includes(searchTerm) ||
          data.language.toLowerCase().includes(searchTerm) ||
          data.name.toLowerCase().includes(searchTerm) ||
          data.artist.includes(artistFilter)
      );
      setFilteredSongs(filtered);
    } else {
      setFilteredSongs(null);
    }
  }, [searchTerm]);

  useEffect(() => {
    const filtered = allSongs?.filter((data) => data.artist === artistFilter);
    if (filtered) {
      setFilteredSongs(filtered);
    } else {
      setFilteredSongs(null);
    }
  }, [artistFilter]);

  useEffect(() => {
    const filtered = allSongs?.filter(
      (data) => data.category.toLowerCase() === filterTerm
    );
    if (filtered) {
      setFilteredSongs(filtered);
    } else {
      setFilteredSongs(null);
    }
  }, [filterTerm]);

  useEffect(() => {
    const filtered = allSongs?.filter((data) => data.album === albumFilter);
    if (filtered) {
      setFilteredSongs(filtered);
    } else {
      setFilteredSongs(null);
    }
  }, [albumFilter]);

  useEffect(() => {
    const filtered = allSongs?.filter(
      (data) => data.language === languageFilter
    );
    if (filtered) {
      setFilteredSongs(filtered);
    } else {
      setFilteredSongs(null);
    }
  }, [languageFilter]);

  return (
    <div className="w-full h-auto flex flex-col items-center justify-center bg-primary">
      <Header />
      <SearchBar />

      {searchTerm.length > 0 && (
        <p className="my-4 text-base text-textColor">
          Searched for :
          <span className="text-xl text-cartBg font-semibold">
            {searchTerm}
          </span>
        </p>
      )}

      <Filter setFilteredSongs={setFilteredSongs} />

      <div className="w-full h-auto flex items-center justify-evenly gap-4 flex-wrap p-4">
        <HomeSongContainer musics={filteredSongs ? filteredSongs : allSongs} />
      </div>
    </div>
  );
};

export const HomeSongContainer = ({ musics, likes, messages, shares }) => {
  const [{ isSongPlaying, song }, dispatch] = useStateValue();
  const [pause, setPause] = useState(false);

  const addSongToContext = (index) => {
    if (!isSongPlaying) {
      dispatch({
        type: actionType.SET_SONG_PLAYING,
        isSongPlaying: true,
      });
    }
    if (song !== index) {
      dispatch({
        type: actionType.SET_SONG,
        song: index,
      });
    }
  };

  const [describe, setDescribe] = useState(true);
  const handleDescribe = () => {
    setDescribe(!describe);
  };

  return (
    <div className="md:grid md:mt-[6%] grid-cols-6 gap-7 scroll-smooth">
      {musics?.map((data, index) => (
        <motion.div
          key={data._id}
          whileTap={{ scale: 0.8 }}
          initial={{ opacity: 0, translateX: -50 }}
          animate={{ opacity: 1, translateX: 0 }}
          transition={{ duration: 0.3, delay: index * 0.1 }}
          className="relative w-96 md:w-40 min-w-210 px-2 py-4 cursor-pointer hover:shadow-xl hover:bg-card hover:border-x-2 duration-200
           border-blue-600 bg-gray-100 shadow-md rounded-lg flex flex-col items-center"
        >
          <div className="w-40 min-w-[160px] h-40 min-h-[160px] rounded-lg drop-shadow-lg relative overflow-hidden">
            <motion.img
              whileHover={{ scale: 1.05 }}
              src={data.imageURL}
              alt=""
              className=" w-full h-full rounded-lg object-cover"
            />
          </div>
          <BsPlayCircle
            className="text-7xl absolute text-blue-600 bg-white opacity-80 rounded-full top-[25%]"
            onClick={() => addSongToContext(index)}
          />
          {/* <BsPauseCircle className="text-7xl absolute text-blue-600 bg-white opacity-80 rounded-full top-[25%]" /> */}
          <p className="text-base text-headingColor font-semibold my-2">
            {data.name.length > 25 ? `${data.name.slice(0, 25)}` : data.name}
            <span className="block text-sm text-gray-400 my-1">
              C/M:
              {data.artist}
              {/* {data.description} */}
            </span>
            <span className="block text-sm text-gray-400 my-1">
              By.
              {data.album.length > 9 ? `${data.album.slice(0, 9)}` : data.album}
              ...
            </span>
            <button className="block text-sm absolute left-[75%] top-[72%] text-gray-400 my-1">
              {data.language.length > 3
                ? `${data.language.slice(0, 3)}`
                : data.language}
              ...
            </button>
            {/* <FaChevronCircleDown
              className="absolute top-[73%] text-2xl left-[87%] text-gray-500"
              onClick={handleDescribe}
            /> */}
            <Comments likes={likes} shares={shares} messages={messages} />
          </p>
          {!describe ? (
            <div className="md:w-[100%] md:h-[100%] border-b-2 border-gray-600 h-[100%] w-[90%] z-30 rounded-md bg-gray-200 absolute">
              <AiOutlineCloseCircle
                className="text-2xl text-gray-800"
                onClick={handleDescribe}
              />
              <p>{data.description}</p>
              <div>
                <motion.img
                  whileHover={{ scale: 1.05 }}
                  src={data.descriptionImageURL}
                  alt=""
                  className=" w-full h-full rounded-lg flex flex-col object-cover"
                />
              </div>
            </div>
          ) : (
            <div className="hidden"></div>
          )}
        </motion.div>
      ))}
    </div>
  );
};

export default Home;
